export const TOP_BAR_HEIGHT = 93;
export const TOP_BAR_Z_INDEX = 100;
